var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99892 8C6.90139 8 6.80387 7.96407 6.72688 7.88708C6.57802 7.73822 6.57802 7.49184 6.72688 7.34299L9.5705 4.49936L6.72688 1.65573C6.57802 1.50687 6.57802 1.26049 6.72688 1.11164C6.87573 0.962786 7.12211 0.962786 7.27096 1.11164L10.3866 4.22731C10.5355 4.37617 10.5355 4.62255 10.3866 4.7714L7.27096 7.88708C7.19397 7.96407 7.09644 8 6.99892 8Z",
    fill: "#F38D00",
    stroke: "#F38D00",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0236 4.88468H1.38497C1.17452 4.88468 1 4.71016 1 4.49971C1 4.28926 1.17452 4.11475 1.38497 4.11475H10.0236C10.2341 4.11475 10.4086 4.28926 10.4086 4.49971C10.4086 4.71016 10.2341 4.88468 10.0236 4.88468Z",
    fill: "#F38D00",
    stroke: "#F38D00",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.b97c3ecdecd2688e62a487a28842c1dd.svg";
export { ForwardRef as ReactComponent };